exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.img {\n  margin-top: 10px;\n}\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/product/category/Edit.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;CAClB","file":"Edit.vue","sourcesContent":["\n.img {\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e0e9185c","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/product/category/Edit.vue
// module id = A/3F
// module chunks = 0